const EIN = /^\d{2}\-?\d{7,8}$/;

export default ein => ein.match(EIN);
